import {useOpenedStateManager} from '@aboutyou/opened-state-manager';

const COUPON_INFO_CONTENT_POPPER_KEY = 'COUPON_INFO_CONTENT_POPPER_KEY';

export const useCouponInfoContentPopperStateManager = (customKey?: string) => {
  const composedKey = `${COUPON_INFO_CONTENT_POPPER_KEY}${customKey || ''}`;
  return useOpenedStateManager(composedKey);
};
